module.exports = __webpack_public_path__ + "img/electricity-colored.857e3983.svg";